import { Component, Input, OnInit } from '@angular/core';
import { Activity, ActivityLog } from '@cbuild/common';
import { COMMUNICATION_TYPE_MAP, LeadActivityEnum } from '@cbuild/enums';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs';
import { CallCenterService } from '../../call-center.service';
import { CallResponseModel } from '../../models/call-response-model';

const ACTIVITY_LOG_DATA_MAP: {
  [key in LeadActivityEnum]?: (data: Activity) => ActivityLog;
} = {
  [LeadActivityEnum.AssigneeChanged]: data => data.userChange[0],
  [LeadActivityEnum.TagChanged]: data => data.tagChange[0],
  [LeadActivityEnum.ExistingLead]: data => data.leadCreated[0],
  [LeadActivityEnum.LeadCreated]: data => data.leadCreated[0],
  [LeadActivityEnum.PipelineChanged]: data => data.pipelineChange[0],
  [LeadActivityEnum.PriorityChanged]: data => data.leadPriorityChange[0],
  [LeadActivityEnum.SourceChanged]: data => data.leadCreated[0],
  [LeadActivityEnum.StageChanged]: data => data.leadStageChange[0],
  [LeadActivityEnum.SubSourceChanged]: data => data.leadCreated[0],
  [LeadActivityEnum.DiscountRequest]: data => data.discounts[0],
  [LeadActivityEnum.Communication]: data => data.communication[0]
};

@Component({
  selector: 'cs-lead-activity',
  standalone: false,
  templateUrl: './lead-activity.component.html',
  styleUrls: ['./lead-activity.component.scss']
})
export class LeadActivityComponent implements OnInit {
  @Input()
  public data: CallResponseModel;
  private onDestroy$ = new Subject<void>();
  public activityList: Array<Activity> = [];
  public isLoading: boolean;
  public _activity: Activity;
  public activityLog: ActivityLog;
  public leadActivityEnum = LeadActivityEnum;
  public communicationTypeEnum = COMMUNICATION_TYPE_MAP;

  constructor(private service: CallCenterService) {}

  public ngOnInit(): void {
    const leadId = this.data.leadId;
    this.isLoading = true;
    this.service
      .getLeadActivities({ leadId })
      .pipe(takeUntil(this.onDestroy$), take(1))
      .subscribe(res => {
        if (res.length > 0) {
          this.activityList = res;

          this.isLoading = false;
        } else {
          this.isLoading = false;
        }
      });
  }

  public activityValue(activity: Activity): string {
    this._activity = activity;
    const dataFn = ACTIVITY_LOG_DATA_MAP[activity.activityType];
    if (!dataFn) {
      throw new Error('Data function not defined');
    }
    this.activityLog = dataFn(activity);
    return this.activityLog?.value;
  }

  public activitySubValue(activity: Activity): string {
    this._activity = activity;
    const dataFn = ACTIVITY_LOG_DATA_MAP[activity.activityType];
    if (!dataFn) {
      throw new Error('Data function not defined');
    }
    this.activityLog = dataFn(activity);
    return this.activityLog?.subValue;
  }

  public communicationType(activity: Activity): string {
    this._activity = activity;
    const dataFn = ACTIVITY_LOG_DATA_MAP[activity.activityType];
    if (!dataFn) {
      throw new Error('Data function not defined');
    }
    this.activityLog = dataFn(activity);
    return COMMUNICATION_TYPE_MAP[this.activityLog?.subDetailId];
  }
}
